





































































































import { defineComponent, PropType, computed, useContext } from '@nuxtjs/composition-api';
import ShopFeatures from '~/components/pages/Shop/ShopFeatures.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import { useStore } from '~/composables/useStore';
import { SHOP_ANCHOR, MEDIA_BREAK_POINT } from '~/constants';
import { formatZipCode } from '~/utils';
import { ECSchema } from '~/types/api';

export default defineComponent({
  components: { ShopFeatures, AppImage },
  props: {
    shopDetail: {
      type: Object as PropType<ECSchema<'saleslocation.ShowResponse'>>,
      required: true,
    },
    hasShopNews: {
      type: Boolean,
      required: true,
    },
    hasNearbySalesLocation: {
      type: Boolean,
      required: true,
    },
    hasBar: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const { i18n } = useContext();
    const SHOP_SECTIONS = [
      {
        anchor: SHOP_ANCHOR.BASIC_INFO,
        title: i18n.t('Other-03.anchorText.basicInfo').toString(),
      },
      {
        anchor: SHOP_ANCHOR.BAR,
        title: i18n.t('Other-03.anchorText.bar').toString(),
      },
      {
        anchor: SHOP_ANCHOR.SHOP_NEWS,
        title: i18n.t('Other-03.anchorText.shopNews').toString(),
      },
      {
        anchor: SHOP_ANCHOR.EVENT_CALENDAR,
        title: i18n.t('Other-03.anchorText.eventCalendar').toString(),
      },
      {
        anchor: SHOP_ANCHOR.BLOG,
        title: i18n.t('Other-03.anchorText.blog').toString(),
      },
      {
        anchor: SHOP_ANCHOR.NEARBY_SHOPS,
        title: i18n.t('Other-03.anchorText.nearbyShops').toString(),
      },
    ];

    const shopPostNum = computed(() => {
      return '〒' + formatZipCode(props.shopDetail.post_no) + ' ';
    });

    /** 店舗住所を結合して返す */
    const shopAddress = computed(() => {
      if (
        props.shopDetail.state_name &&
        props.shopDetail.city_name &&
        props.shopDetail.address_name1 &&
        props.shopDetail.address_name2
      ) {
        return (
          props.shopDetail.state_name +
          props.shopDetail.city_name +
          props.shopDetail.address_name1 +
          props.shopDetail.address_name2
        );
      }
    });

    const storeTypes = computed(() => {
      return props.shopDetail.store_types;
    });

    // 店舗位置を表すGoogleMapUrlを返す
    const shopGoogleMapUrl = computed(() => {
      if (props.shopDetail.googlemap_url) {
        // iframeの要素からsrcに設定されているURL値だけ抽出する
        const matchesUrl = props.shopDetail.googlemap_url.match(/^.*src="(.*)"\s(width=.*)$/);
        if (matchesUrl) {
          return matchesUrl[1];
        }
      }
    });

    const hasSection = (anchor: string) => {
      if (anchor === SHOP_ANCHOR.SHOP_NEWS && !props.hasShopNews) return false;
      if (anchor === SHOP_ANCHOR.NEARBY_SHOPS && !props.hasNearbySalesLocation) return false;
      if (anchor === SHOP_ANCHOR.BAR && !props.hasBar) return false;
      return true;
    };

    // ヘッダメニューの高さを考慮して、セクションにスクロールする
    const scrollToAnchor = (anchor: string) => {
      const anchorElement = document.getElementById(anchor);
      if (!anchorElement) return;
      const windowWidth = window.innerWidth;
      const { headerHeight, headerOffsetTop } = store.state.internals.header;
      let offset = window.scrollY - headerHeight;
      // スマホの場合、ヘッダーメニューの高さを考慮する必要がない
      if (windowWidth < MEDIA_BREAK_POINT.MD) {
        window.scrollTo({
          top: anchorElement.getBoundingClientRect().top + offset,
        });
        return;
      }
      offset = window.scrollY - headerOffsetTop;
      window.scrollTo({
        top: anchorElement.getBoundingClientRect().top + offset,
      });
    };

    return {
      SHOP_SECTIONS,
      SHOP_ANCHOR,
      shopPostNum,
      shopAddress,
      storeTypes,
      shopGoogleMapUrl,
      hasSection,
      scrollToAnchor,
    };
  },
});
